import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { KatexModule } from 'ng-katex';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { QuestionComponent } from './question/question.component';
import { SlideComponent } from './slide/slide.component';
@NgModule({
  declarations: [
    AppComponent,
    QuestionComponent,
    SlideComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    KatexModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
